import moment from 'moment';
import { func, shape } from 'prop-types';
import { Image, List, Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../ContextMenuHeader';

const ConsultDetails = props => {
  const {
    consult: { drugAllergies, medicalConditions, reason, createdAt },
    goBack,
    patient,
    forPatient,
  } = props;
  return (
    <Segment.Group className="context-menu history details">
      <ContextMenuHeader title="Consult Details" goBack={goBack} />
      <Segment className="body">
        <List relaxed="very" className="consult-details">
          <List.Item>
            <List.Header>FOR PATIENT</List.Header>
            <List.List>
              <List.Item>
                <Image avatar src={forPatient.avatarUrl} />
                <List.Content verticalAlign="middle">{forPatient.fullName}</List.Content>
              </List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>REQUESTED BY</List.Header>
            <List.List>
              <List.Item>
                <Image avatar src={patient.avatarUrl} />
                <List.Content verticalAlign="middle">{patient.fullName}</List.Content>
              </List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>ON</List.Header>
            <List.List>
              <List.Item>
                <List.Icon name="calendar outline" />
                <List.Content verticalAlign="middle">
                  {moment(createdAt).format('MMMM D, YYYY')}
                </List.Content>
              </List.Item>
            </List.List>
          </List.Item>
          <List.Item>
            <List.Header>REASON FOR CONSULTATION</List.Header>
            <List.Content className="reason">{reason}</List.Content>
          </List.Item>
          <List.Item>
            <List.Header>PRE-EXISTING MEDICAL CONDITIONAL</List.Header>
            <List.Content className="reason">{medicalConditions}</List.Content>
          </List.Item>
          <List.Item>
            <List.Header>DRUG ALLERGY</List.Header>
            <List.Content className="reason">{drugAllergies}</List.Content>
          </List.Item>
        </List>
      </Segment>
    </Segment.Group>
  );
};

ConsultDetails.propTypes = {
  consult: shape({}).isRequired,
  patient: shape({}).isRequired,
  forPatient: shape({}).isRequired,
  goBack: func.isRequired,
};

export default ConsultDetails;
